import axios from "axios";
import { header } from "../utils/header";
import { updateHospital } from "../utils/types";
import { baseURL } from "../utils/constants";
import apiClient from "./fetch";

//Get Hospitals by User ID
export const getHospitalListByUserId = async (user_id: string) => {
  try {
    const res = await apiClient.get(`${baseURL}/user/${user_id}/hospitals`);
    return res;
  } catch (error: any) {
    if (error.response && error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Update Hospital
export const updateHosptialDetails = async ({
  hospital_id,
  hospital_name,
  hospital_timing,
  hospital_address,
  logo,
  
}: updateHospital) => {
  const res = await apiClient.put(`${baseURL}/hospital/${hospital_id}`, {
    name: hospital_name,
    timing: hospital_timing,
    address: hospital_address,
    logo: logo,
  });
  return res;
};

//GET HOSPITAL DETAILS
export const getHosptialDetails = async (id: string | undefined) => {
  try {
    const res = await apiClient.get(`${baseURL}/hospital/${id}`);
    return res;
  } catch (error: any) {
    if (error.response && error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//START BOT CHAT
export const startBotChat = async (hospital_contact_number: string | undefined,hospital_name: string | undefined,receiverNumber:string,lang:string) => {
  try {
    const res = await apiClient.post(`${baseURL}/hospital/startchat`,{
      hospital_contact_number: hospital_contact_number,
      hospital_name: hospital_name,
      receiverNumber: receiverNumber,
      lang: lang || 'en'
    });
    return res;
  } catch (error: any) {
    if (error.response && error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};
